import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import PipelineAutomationsAPI from '../../api/pipelineAutomations';

export const state = {
  records: [],
  availableConfig: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingConfig: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getPipelineAutomations(_state) {
    return _state.records;
  },
  getByPipeline: _state => pipelineId => {
    if (!pipelineId) return _state.records;
    return _state.records.filter(
      a => String(a.pipeline_id) === String(pipelineId)
    );
  },
  getAvailableConfig(_state) {
    return _state.availableConfig;
  },
};

export const actions = {
  get: async function getPipelineAutomations({ commit }, params = {}) {
    commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isFetching: true });
    try {
      const response = await PipelineAutomationsAPI.get(params);
      commit(
        types.SET_PIPELINE_AUTOMATIONS,
        response.data.payload || response.data
      );
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isFetching: false });
    }
  },
  getByPipeline: async function getByPipeline({ commit }, pipelineId) {
    commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isFetching: true });
    try {
      const response = await PipelineAutomationsAPI.get({
        pipeline_id: pipelineId,
      });
      commit(
        types.SET_PIPELINE_AUTOMATIONS,
        response.data.payload || response.data
      );
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isFetching: false });
    }
  },
  fetchAvailableConfig: async function fetchAvailableConfig({ commit }) {
    commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isFetchingConfig: true });
    try {
      const response = await PipelineAutomationsAPI.getAvailableConfig();
      commit('SET_AVAILABLE_CONFIG', response.data);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, {
        isFetchingConfig: false,
      });
    }
  },
  create: async function createPipelineAutomation({ commit }, automationObj) {
    commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isCreating: true });
    try {
      const response = await PipelineAutomationsAPI.create(automationObj);
      commit(types.ADD_PIPELINE_AUTOMATION, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isUpdating: true });
    try {
      const response = await PipelineAutomationsAPI.update(id, updateObj);
      commit(types.EDIT_PIPELINE_AUTOMATION, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isUpdating: false });
    }
  },
  toggleActive: async ({ commit }, { id, active }) => {
    commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isUpdating: true });
    try {
      const response = await PipelineAutomationsAPI.update(id, {
        pipeline_automation: { active },
      });
      commit(types.EDIT_PIPELINE_AUTOMATION, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isDeleting: true });
    try {
      await PipelineAutomationsAPI.delete(id);
      commit(types.DELETE_PIPELINE_AUTOMATION, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PIPELINE_AUTOMATION_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_PIPELINE_AUTOMATION_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_PIPELINE_AUTOMATION]: MutationHelpers.create,
  [types.SET_PIPELINE_AUTOMATIONS]: MutationHelpers.set,
  [types.EDIT_PIPELINE_AUTOMATION]: MutationHelpers.update,
  [types.DELETE_PIPELINE_AUTOMATION]: MutationHelpers.destroy,
  SET_AVAILABLE_CONFIG(_state, config) {
    _state.availableConfig = config;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
